import ToolService from '@/services/Tool.js';
import { formatPrice } from '@/utils/number.js';

export default {
  data() {
    return {
      minBudget: null,
      isBudgetRequestRunning: false,
    };
  },
  computed: {
    invalidBudget() {
      return !this.isBudgetRequestRunning && this.budget && this.budget < this.minBudget;
    },
    minBudgetInfoText() {
      let text = '';

      if (this.budgetPeriod === 'daily') {
        text = this.tr('Minimum daily budget') + ': ';
      }
      else {
        text = this.tr('Minimum budget') + ': ';
      }

      if (this.minBudget === null) {
        text += '...';
      }
      else {
        text += formatPrice(this.minBudget, this.budgetCurrencySymbol);
      }

      return text;
    },
    invalidBudgetInfoText() {
      return this.tr('Budget must be more than <span class="budget">:value</span>!', {
        ':value': formatPrice(this.minBudget, this.budgetCurrencySymbol),
      });
    },
  },
  methods: {
    getMinBudget() {
      if (
        !this.budgetPeriod
        || !this.budgetAdAccountId
      ) {
        return;
      }

      this.isBudgetRequestRunning = true;
      this.minBudget = null;

      let startTime = null;
      let endTime = null;
      let lifespanMaxDays = null;

      if (this.budgetPeriod === 'lifetime') {
        const start = this.budgetLifetimeStartTime;
        const end = this.budgetLifetimeEndTime;
        if (start && end) {
          startTime = (start instanceof Date ? start : new Date(start)).toISOString();
          endTime = (end instanceof Date ? end : new Date(end)).toISOString();
        }
        lifespanMaxDays = this.budgetLifetimeLifespanMaxDays || null;
      }

      ToolService.getMinimumBudget(
        this.budgetAdAccountId,
        this.budgetLevel,
        this.budgetPeriod,
        startTime,
        endTime,
        lifespanMaxDays,
      )
        .then(response => {
          this.minBudget = response.min_budget;
          return response.min_budget;
        })
        .catch(err => this.error(err))
        .finally(() => this.isBudgetRequestRunning = false);
    },
  },
};
